class HekateFormElementValidationDefinition {
    constructor({ name }) {
        this.name = name;
    }
    static fromBlob(blob) {
        var _a, _b;
        const conditionType = (_b = (_a = blob.condition) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : blob.name;
        let name;
        switch (conditionType) {
            case 'IsRequiredCondition':
                name = 'IsRequiredCondition';
                break;
            case 'IsEmailAddressCondition':
                name = 'IsEmailAddressCondition';
                break;
            case 'PreventUrlCondition':
                name = 'PreventUrlCondition';
                break;
            case 'PreventXSSCondition':
                name = 'PreventXSSCondition';
                break;
            case 'TextLengthCondition':
                name = 'TextLengthCondition';
                break;
            default:
                console.log('unsupported condition: ', conditionType);
                name = 'unsupported';
        }
        return new HekateFormElementValidationDefinition({
            name,
        });
    }
    /** Logically compare (suitable for serialization check) */
    compareTo(rhs) {
        return this.name === rhs.name;
    }
}
HekateFormElementValidationDefinition.IsRequiredCondition = new HekateFormElementValidationDefinition({
    name: 'IsRequiredCondition',
});
export default HekateFormElementValidationDefinition;
